<template>
    <div>
        <nav
            v-if="showClientNavBar"
            style="position: fixed"
            class="navbar navbar-client navbar-dark bg-dark"
        >
            <div class="nav-wrapper">
                <div class="burger-phone__flex">
                    <div
                        class="burger"
                        :class="{ active: menu }"
                        @click="toggleMenu"
                    >
                        <span class="burger__line burger__line--top"/>
                        <span class="burger__line burger__line--center"/>
                        <span class="burger__line burger__line--bottom"/>
                    </div>
                </div>
                <symbol
                    id="k-logo"
                    viewBox="0 0 135 23"
                >
                    <path
                        fill="#ddd5c7"
                        d="M.173 19.238c.618.741 1.104.918 1.772.668a1.557 1.557 0 0 0 1.023-1.671V4.962A1.439 1.439 0 0 0 1.235 3.42a4.168 4.168 0 0 0-1.1.599 2.86 2.86 0 0 1 2.1-3.516 3.617 3.617 0 0 1 3.172.63.688.688 0 0 0 1.023.017A3.683 3.683 0 0 1 8.877.395v.528q0 8.554.004 17.109a3.715 3.715 0 0 0 .098.914 1.384 1.384 0 0 0 1.3 1.072c.65.042.834-.18.917-.82a19.582 19.582 0 0 1 .558-3.194 7.596 7.596 0 0 1 3.484-4.284c1.175-.716 2.428-1.304 3.64-1.96a16.94 16.94 0 0 0 1.866-1.075 2.623 2.623 0 0 0 .113-4.431 3.254 3.254 0 0 0-3.965-.293 3.356 3.356 0 0 0-1.45 3.725c.28 1.097.158 1.327-.986 1.54a3.984 3.984 0 0 1-1.435.004 1.987 1.987 0 0 1-1.756-2.141 26.74 26.74 0 0 1 .453-3.258c.205-1.138.475-2.264.721-3.415a.343.343 0 0 1 .159.051 3.483 3.483 0 0 0 2.95.432C16.944.62 18.334.3 19.742.106a7.843 7.843 0 0 1 6.416 1.635 5.478 5.478 0 0 1-.348 8.856 26.146 26.146 0 0 1-3.125 1.702 17.769 17.769 0 0 0-3.934 2.4 3.583 3.583 0 0 0-1.198 2.006 1.593 1.593 0 0 0 .97 1.904 4.255 4.255 0 0 0 2.42.278 11.93 11.93 0 0 0 2.036-.529.884.884 0 0 0 .433-.538 2.098 2.098 0 0 0-.107-1.709c-.222-.399-.01-.677.295-.901a2.905 2.905 0 0 1 2.368-.384c1.856.355 2.703 1.759 2.268 3.781-.24 1.117-.584 2.212-.867 3.32-.083.326-.118.663-.16.907a22.902 22.902 0 0 0-2.772-.375 18.41 18.41 0 0 0-3.283.232 16.053 16.053 0 0 1-5.258.127 3.948 3.948 0 0 1-2.208-1.065c-1.959 1.482-4.106 1.457-6.316.88a4.262 4.262 0 0 1-1.055-.523.528.528 0 0 0-.706.015 4.086 4.086 0 0 1-2.89.853 2.94 2.94 0 0 1-2.548-3.74zm42.319-8.775a9.04 9.04 0 0 0 3.424-.367c1.048-.567 1.444-2.067 1.982-4.303.679-2.463 2.405-4.388 6.764-3.481v2.886c-1.585-.141-2.434.34-2.858 1.84a11.292 11.292 0 0 1-2.491 5.265l6.057 9.17v.624h-4.783l-4.982-8.152a15.927 15.927 0 0 1-3.114.198v7.954h-4.217V2.283h4.217zm19.897.311v11.323h-4.217V2.198h1.33l11.124 11.323V2.283h4.246v19.87h-1.274zM88.43 22.38c-5.293 0-10.076-3.51-10.076-10.19S83.25 2 88.514 2a9.738 9.738 0 0 1 10.078 10.19c0 6.029-4.161 10.19-10.162 10.19zm.056-3.878c3.086 0 5.888-1.981 5.888-6.313 0-4.216-2.774-6.283-5.86-6.283-3.112 0-5.886 2.095-5.886 6.283 0 4.332 2.689 6.313 5.858 6.313zM100.29 5.963v-3.68h14.662v3.68h-5.264v16.134h-4.105V5.963zm20.407 10.133c.085 1.811 2.067 2.576 3.992 2.576 1.755 0 3.793-.397 3.793-2.463 0-2.18-2.435-2.349-4.331-2.49-3.595-.312-7.218-1.388-7.218-5.491C116.932 3.84 120.528 2 124.462 2c3.707 0 7.557 1.557 7.557 6.001h-3.963c-.227-1.613-1.897-2.321-3.595-2.321-1.726 0-3.368.934-3.368 2.463 0 1.754 1.727 2.01 3.793 2.235 4.188.368 7.784 1.19 7.784 5.831 0 4.67-4.048 6.086-7.954 6.17-3.963 0-8.067-1.952-8.067-6.283z"
                    />
                </symbol>
                <div class="navbar-left mr-auto">
                    <a
                        href="https://12knots.com"
                        class="navbar-brand"
                    >
                        <svg
                            width="135px"
                            height="23px"
                        >
                            <use xlink:href="#k-logo"/>
                        </svg>
                    </a>
                </div>

                <div class="right lh-reset actions-block">
                    <button
                        class="actions-block__avatar avatar btn-reset"
                        @click.prevent="tooltip = !tooltip"
                    >
                        <span class="avatar__username">{{ client && client.name ? client.name : name }}</span>
                        <img
                            class="avatar__image"
                            src="../../assets/Group8.svg"
                        >
                    </button>
                    <!-- <div class="actions-block__flag">
            <img src="../../assets/flag.svg" />
          </div> -->
                    <div
                        v-if="tooltip"
                        class="my-tooltip"
                    >
                        <div style="width: 69%">
                            <ClientSidebar/>
                        </div>
                        <div class="auth-card__button button">
                            <button
                                class="auth-card__button_button"
                                type="submit"
                                @click.prevent="logout"
                            >
                                Sign out
                            </button>
                        </div>
                    </div>
                    <a
                        class="phone navbar__phone"
                        href="tel:+18889173773"
                    > +1 888 917 37 73 </a>
                </div>
            </div>
        </nav>

        <nav
            v-else
            class="navbar white"
        >
            <div class="nav-wrapper">
                <div class="navbar-left">
                    <a
                        href="#"
                        @click.prevent="toggleMenu"
                    >
                        <i class="material-icons black-text">menu</i>
                    </a>
                    <img
                        class="logo"
                        src="../../assets/logo_test.png"
                        alt="12knots"
                    >
                    <span class="navbar-date">{{ $filters.date(date, "datetime") }}</span>
                </div>
                <div
                    v-if="isOut"
                    class="right"
                >
                    <span
                        class="new badge red"
                        data-badge-caption=""
                    >Out of office</span>
                </div>
                <div class="right lh-reset navbar__actions">
                    <a
                        ref="dropdown_messages"
                        class="dropdown-trigger black-text"
                        href="#"
                        data-target="dropdown-messages"
                    >
                        <span>Messages <span class="count-messages">{{countMessages}}</span></span>
                        <i class="material-icons right">arrow_drop_down</i>
                    </a>
                    <ul class="dropdown-content" id="dropdown-messages">
                        <template v-if="notifications.length">
                            <li v-for="(msg,k) in notifications" :key="msg.id">
                                    <i class="material-icons">message</i>
                                    <span class="dropdown-message">{{ msg.message }}</span>
                                    <a class="btn-floating btn-small waves-effect waves-light red lighten-1 remove-message "
                                       @click.stop.prevent="deleteMessage(msg.id)"
                                    >
                                        <i class="material-icons">remove</i>
                                    </a>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="right lh-reset navbar__actions">
                    <a
                        ref="dropdownadmin"
                        class="dropdown-trigger black-text"
                        href="#"
                        data-target="dropdown-admin"
                    >
                        <span>{{ name }}</span>
                        <i class="material-icons right">arrow_drop_down</i>
                    </a>

                    <ul
                        id="dropdown-admin"
                        class="dropdown-content"
                    >
                        <li>
                            <router-link
                                :to="profileLink"
                                class="black-text"
                            >
                                <i class="material-icons">account_circle</i>
                                <span>Profile</span>
                            </router-link>
                        </li>
                        <li
                            class="divider"
                            tabindex="-1"
                        />
                        <li v-if="isAdmin">
                            <router-link
                                to="/register"
                                class="black-text"
                            >
                                <i class="material-icons">supervised_user_circle</i>
                                <span class="no-wrap">Add user</span>
                            </router-link>
                        </li>
                        <li
                            class="divider"
                            tabindex="-1"
                        />
                        <li>
                            <a
                                href="#"
                                class="black-text"
                                @click.prevent="logout"
                            >
                                <i class="material-icons">assignment_return</i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import ClientSidebar from "@/components/app/ClientSidebar";
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import {useEcho} from "@/composables/echo";

export default {
    components: {ClientSidebar},
    props: {
        menu: Boolean,
    },
    emits: ['toggleMenu'],
    data: () => ({
        date: new Date(), //.toLocaleString(),
        interval: null,
        dropdown: null,
        dropdown_messages: null,
        user: null,
        tooltip: false,
        notifications: []
    }),
    computed: {
        currentUser() {
            return this.$store.getters.user;
        },
        showClientNavBar() {
            return this.isClient || _.isEmpty(this.currentUser);
        },
        name() {
            return this.isNotEmpty(this.$store.getters.user)
                ? this.$store.getters.user.name
                : "Guest";
        },
        client() {
            return this.$store.getters.client ? this.$store.getters.client :
                (this.$store.getters.user?.client ? this.$store.getters.user.client : null);
        },
        isClient() {
            return this.$role("client");
        },
        isAdmin() {
            return this.$role("super-admin");
        },
        isOut() {
            if (this.user && this.user?.manager?.is_out) {
                return true;
            }
            return false;
        },
        profileLink() {
            if (this.$role("client")) {
                return "/account/profile";
            }

            return "/profile";
        },
        messages() {
            return this.$store.getters.messages ? this.$store.getters.messages : [];
        },
        countMessages() {
            return this.notifications.length;
        }
    },
    async mounted() {
        if(localStorage.getItem('token')) {
            useEcho(localStorage.getItem('token'));
            if(window.Echo && this.$store.getters.user) {
                console.log('echo')
                window.Echo.private('user.' + this.$store.getters.user.id)
                    // .listen('CrewListSaved', (res) => {
                    .listen('.new_message', (res) => {
                        this.addMessage(res);
                    });
            }
        }
        this.user = this.$store.getters.user;
        if (this.$role("client")) {
            this.dropdown = M.Dropdown.init(this.$refs.dropdownclient, {
                constrainWidth: false,
                alignment: "right",
            });
        } else {
            this.dropdown = M.Dropdown.init(this.$refs.dropdownadmin, {
                constrainWidth: false,
                alignment: "right",
            });
            this.dropdown_messages = M.Dropdown.init(this.$refs.dropdown_messages, {
                closeOnClick: false,
                constrainWidth: false,
                alignment: "right",
            });
        }
        this.interval = setInterval(() => {
            this.date = new Date();
        }, 1000);

        if(this.messages.length) {
            this.messages.forEach( m => {
                this.notifications.push({
                    id: m.id,
                    message: m.message,
                });
            })
        }


    },
    methods: {
        async logout() {
            await this.$store.dispatch("signOut");
            this.$router.push("/signin?message=logout");
        },
        beforeUnmount() {
            clearInterval(this.interval);
            if (this.dropdown && this.dropdown.destroy) {
                this.dropdown.destroy();
            }
        },
        toggleMenu() {
            this.$emit('toggleMenu');
        },
        async deleteMessage(id) {
            const ind = this.notifications.findIndex( m => m.id === id);
            if(ind > -1) {
                const id = this.notifications[ind].id;
                this.notifications.splice(ind,1)
                try {
                    await this.$store.dispatch('deleteMessage',id);
                } catch (err) {
                    console.log(err);
                }
            }
        },
        addMessage(res) {
            if(res) {
                // const raw = JSON.parse(event.data);
                // const data = JSON.parse(raw.data)
                const message = res.data ? res.data?.message : res.message;
                const id = res.data ? res.data?.id : res.id;
                if(message) {
                    this.$message("new message");
                    this.notifications.push( {
                        id, message
                    });
                }
            }
        }
    },
};
</script>
<style lang="scss" scoped>

.phone {
    color: #a09e99;
    font-size: 17px;
    cursor: pointer;

    &:hover {
        transition: 0.4s;
        color: #ffffff;
    }
}


.logo {
    height: 45px;
    margin-right: 100px;
    margin-left: 8px;
    @media screen and (max-width: 768px) {
        margin-right: 8px;
    }
}

.navbar {
    box-shadow: none;
    border-bottom: solid 1px rgba(51, 51, 51, 0.12);

    &-date {
        color: rgba(0, 0, 0, 0.87);
        @media screen and (max-width: 768px) {
            display: none;
        }
    }
}

.user-dropdown {
    & li {
        display: flex;
    }
}

.navbar-client {
    position: relative;
    align-items: center;
    min-height: 56px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.navbar-dark .navbar-brand {
    color: #9a8374;
}

.navbar-text {
    color: #9f9e98;
}

.bg-dark {
    background-color: #2a2826 !important;
}

.navbar__phone {
    color: white;
    font-weight: 300;
}
.count-messages {
    color: white;
    border-radius: 50%;
    background-color: #0d47a1;
    display: inline-flex;
    padding: 5px;
    min-width: 30px;
    justify-content: center;
}
#dropdown-messages li {
    display: flex;
    padding: 5px 10px;
    justify-content: space-between;
}

#dropdown-messages .dropdown-message {
    color: #0a0a0a;
}

#dropdown-messages .remove-message {
    padding: 5px;
    margin-top: 5px;
}


</style>
